import { BookIcon, Box, Row, TextWithTooltip } from "@hightouch/htui";
import type { FC } from "react";
import { usePartner } from "src/partner/context";

import { Link } from "src/router";

type Props = {
  href: string | null | undefined;
  label?: string;
  name?: string;
};

export const DocsLink: FC<Readonly<Props>> = ({ href, label, name }) => {
  const { isPartner } = usePartner();

  // Don't show Hightouch docs for embedded views
  if (isPartner) {
    return null;
  }

  if (!href) {
    return null;
  }

  return (
    <Link
      isExternal
      isTruncated
      href={`${import.meta.env.VITE_DOCS_URL}${
        href.startsWith("/") ? href : `/${href}`
      }`}
    >
      <Row gap={1} align="center" overflow="hidden">
        <Box as={BookIcon} boxSize={4} flexShrink={0} />
        <TextWithTooltip color="inherit">
          {label ?? `Docs for ${name}`}
        </TextWithTooltip>
      </Row>
    </Link>
  );
};
